import { createApi } from '@reduxjs/toolkit/query/react';
import qs from 'qs';
import { baseQueryWithAuth } from './baseQueryWithAuth';
const DeviceApiService = createApi({
  reducerPath: 'deviceApi',
  baseQuery: baseQueryWithAuth,
  paramsSerializer: params => qs.stringify(params, { encode: false }),
  endpoints: builder => ({
    getDevices: builder.query({
      query: () => {
        return {
          url: `/devices`,
          method: 'GET',
        };
      },
    }),
  }),
});

export const { useGetDevicesQuery } = DeviceApiService;

export default DeviceApiService;
